<template>
  <div class="container py-3">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h4 class="mb-0">Admin: Chi tiết phiếu công</h4>
      <router-link class="btn btn-outline-secondary btn-sm" to="/admin/phieu-cong">Quay lại</router-link>
    </div>

    <div v-if="store.loading" class="alert alert-info">Đang tải...</div>
    <div v-if="store.error" class="alert alert-danger">{{ store.error }}</div>

    <div v-if="slip" class="card p-3">
      <div class="d-flex justify-content-between flex-wrap">
        <div>
          <div class="fw-bold">{{ slip.hoTen }} ({{ slip.phongBan }})</div>
          <div class="text-muted small">Tháng {{ slip.month }} | Mode {{ slip.kieuChamCong }}</div>
        </div>
        <div><span class="badge bg-secondary">Status: {{ slip.status }}</span></div>
      </div>

      <hr />

      <div class="mb-2">
        <div class="small text-muted">Chữ ký:</div>
        <div v-if="slip.signature">
          <div><b>{{ slip.signature.name }}</b> - {{ slip.signature.signedAt }}</div>
          <img v-if="slip.signature.imageDataUrl" :src="slip.signature.imageDataUrl" style="max-width: 320px" />
        </div>
        <div v-else class="text-muted">Chưa ký</div>
      </div>

      <div class="table-responsive mt-3">
        <table class="table table-sm table-bordered align-middle">
          <thead>
            <tr class="table-light">
              <th>Ngày</th><th>Công</th><th>Trễ</th><th>Ra sớm</th><th>Quên</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="d in slip.snapshot.daily" :key="d.day">
              <td>{{ d.day }}</td>
              <td>{{ d.soCong }}</td>
              <td>{{ d.tongVaoTre }}</td>
              <td>{{ d.tongRaSom }}</td>
              <td>{{ d.tongQuenCham }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-3 d-flex gap-2 flex-wrap">
        <input v-model="note" class="form-control" placeholder="Ghi chú admin..." style="max-width: 420px" />

        <button class="btn btn-success" @click="verify" :disabled="slip.status !== 'SIGNED'">
          Verify
        </button>
        <button class="btn btn-danger" @click="reject">
          Reject
        </button>

        <a v-if="slip.payrollPdfUrl" class="btn btn-outline-secondary" :href="slip.payrollPdfUrl" target="_blank">
          Xem phiếu lương (mock)
        </a>
      </div>

      <div v-if="slip.adminNote" class="alert alert-secondary mt-3">
        Admin note: {{ slip.adminNote }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { usePhieuCongStore } from "@/stores/phieuCongStore";

const store = usePhieuCongStore();
const route = useRoute();

const note = ref("OK");
const slip = computed(() => store.adminDetail);

onMounted(() => store.fetchAdminDetail(route.params.id));

function verify() {
  store.verify(route.params.id, note.value);
}
function reject() {
  store.reject(route.params.id, note.value || "Thiếu dữ liệu");
}
</script>
